// A tab opened before a deploy, asking for a page of the dashboard it has not
// loaded yet. Each page is its own file (App.tsx loads them lazily) whose name
// changes with every build, and the deploy removed the old one: Hosting
// answers with the app's HTML instead, the import fails, and the screen went
// blank. Vite reports the failure as "vite:preloadError"; reloading fetches
// the new build, whose files exist.
//
// Once per minute at most, so a file that is missing for some other reason
// shows its error instead of reloading forever.

const RELOADED_KEY = "buildbotsnow.staleBuildReload";
const RETRY_AFTER_MS = 60_000;

export function reloadOnStaleBuild(win: Window = window, now: () => number = Date.now): void {
  win.addEventListener("vite:preloadError", (event) => {
    let last = 0;
    try {
      last = Number(win.sessionStorage.getItem(RELOADED_KEY)) || 0;
    } catch {
      // Storage blocked: still reload, the browser's own cache does the rest.
    }
    if (now() - last < RETRY_AFTER_MS) return;
    event.preventDefault();
    try {
      win.sessionStorage.setItem(RELOADED_KEY, String(now()));
    } catch {
      // As above.
    }
    win.location.reload();
  });
}
